import {
  Component,
  OnInit,
  Input,
  ViewChild,
  TemplateRef,
  Output,
  EventEmitter
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EmailService } from '../email.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { IEmail } from '../../../models/email';
import { ISession } from '../../../models/session';
import { union, contains, reduce } from 'ramda/es';
import { TagsFormatService } from '../../tags/tags-format.service';
import { ValidateImportService, IValidateResults } from '../editor/validate.import.service';
import { SimpleFileUploadComponent } from '../../sessions/file-upload/simple-file-upload.component';
import { MailingListModalComponent } from '../../modals/mailinglist/mailinglist-modal.component'
import { ConfirmationModalComponent } from '../../modals/confirmation/confirmation-modal.component'
import loader from '../editor/editor.loader';
import { omit } from 'ramda';

@Component({
  templateUrl: './editor.component.html',
  selector: 'email-editor-2',
  styleUrls: ['../email.component.scss']
})
export class EmailEditorComponent2 implements OnInit {
  @ViewChild('testMailModal') testMailModal: any;
  @ViewChild('object') object: any;
  @ViewChild('validateImport') validateImportModal: TemplateRef<any>;
  @ViewChild(SimpleFileUploadComponent) fileUpload: SimpleFileUploadComponent;
  @ViewChild('ignoredEmailsWarning') ignoredEmailsWarning: TemplateRef<any>;
  @ViewChild('sendMailsModal') sendMailsModal: TemplateRef<any>;

  @Input('can-send') canSend = true;
  @Input('session') session: ISession;
  @Input() completions = [];

  @Input('email')
  email: IEmail = {
    type: '',
    language: '',
    subject: '',
    fromName: '',
    content: '',
    schedule: '',
    scheduleat: '',
    hasSchedule: false,
    hasMailingList: false
  };
  public types = ['confirmations', 'alerts', 'invitations', 'accounts'];
  public times = [1, 6, 10, 12, 24];

  public saved = true;
  public modalRef: BsModalRef;
  public testAddress = '';
  public mailingAddress = '';
  public mailingList: Array<string> = [];
  public loadingElement: 'mailing' | 'preview' | '' = '';
  private validateResults: IValidateResults = { validEmails: [], rejectedEmails: [] };
  private ignoredEmails: Array<string>;
  private remainingMailingList: Array<string> = [];
  
  @Output() onSave = new EventEmitter<{ email: IEmail }>();
  @Output() onSaveMailingList = new EventEmitter<{ type: string; mailingList: Array<string> }>();
  @Output() onRemoveMailingList = new EventEmitter<{ type: string; mailingList: Array<string> }>();
  @Output() onSendMail = new EventEmitter<{ type: string }>();
  @Output() onReSendMail = new EventEmitter<{ type: string }>();
  @Output() onSendTestMail = new EventEmitter<{ type: string; address: string }>();
  @Output() onSendOndemandMail = new EventEmitter<{ type: string; mailingList: Array<string> }>();

  constructor(
    private translateService: TranslateService,
    private modalService: BsModalService,
    private emailService: EmailService,
    private validateImportService: ValidateImportService
  ) {}

  ngOnInit() {}

  ngAfterViewInit() {
    this.translateService
      .get('sessions.details.emails.warning_import')
      .subscribe(warningImportText => {
        $('.wrapper-content').tooltip({
          title: warningImportText,
          placement: 'top',
          selector: '.import-emails'
        });
      });
  }

  isInvitations(): boolean {
    return this.email.type === 'invitations';
  }

  isAlerts(): boolean {
    return this.email.type === 'alerts';
  }

  isConfirmations(): boolean {
    return this.email.type === 'confirmations';
  }

  isAccounts(): boolean {
    return this.email.type === 'accounts';
  }

  save() {
    this.onSave.emit({ email: this.email });
    this.saved = true;
  }

  // saveMailingList() {
  //   this.onSaveMailingList.emit({ type: this.email.type, mailingList: this.mailingList });
  // }

  sendMail() {
    this.onSendMail.emit({ type: this.email.type });
  }

  sendTestMail() {
    this.onSendTestMail.emit({ type: this.email.type, address: this.testAddress });
    this.modalRef.hide();
  }

  editMailingList() {
    this.emailService.getMailingList(this.session, this.email.type).subscribe(
      list => {
        const modal = this.modalService.show(MailingListModalComponent, { class: 'inmodal' });
        (<MailingListModalComponent>modal.content).showModal(
          {
            title: this.translateService.instant('sessions.details.emails.mailing_list'),
            confirmTitile: this.translateService.instant('sessions.details.emails.confirmations_edit'),
            clearButton: this.translateService.instant('sessions.details.emails.clear_mailing'),
            confirmButton: this.translateService.instant('common.save'),
            cancelButton: this.translateService.instant('common.cancel')
          }, list || [], true
        ).subscribe(({add, remove}) => {
          if (add.length > 0) {
            // update with empty list will remove all
            this.onSaveMailingList.emit({ type: this.email.type, mailingList: add });
          }
          if (remove.length > 0) {
            this.onRemoveMailingList.emit({ type: this.email.type, mailingList: remove });
          }
        });    
      },
      err => {
        toastr.error(this.translateService.instant('action.failed'));
        this.loadingElement = '';
      }
    );
  }

  onImportFile(file) {
    if (file.type !== 'text/csv' && file.type !== 'application/vnd.ms-excel') {
      return toastr.error(
        this.translateService.instant('sessions.details.emails.error_import_type')
      );
    }
    const fd: FileReader = new FileReader();
    fd.onloadend = () => {
      this.validateResults = this.validateImportService.validate(String(fd.result));
      return (this.modalRef = this.modalService.show(
        this.validateImportModal,
        Object.assign({}, { class: 'inmodal' })
      ));
    };
    fd.readAsText(file);
  }

  importValidEmails(validEmails: Array<string>) {
    this.mailingList = validEmails;
  }

  showModal(template: TemplateRef<any>) {
    if (this.modalRef) {
      this.modalRef.hide();
    }
    this.openModal(template);
  }

  // showMailingList(template: TemplateRef<any>, reload: boolean) {
  //   this.showModal(template);
  //   if (!this.session) {
  //     this.loadingElement = '';
  //     return this.mailingList;
  //   }
  //   if (reload) {
  //     this.loadingElement = 'mailing';
  //     this.emailService.getMailingList(this.session, this.email.type).subscribe(
  //       list => {
  //         this.mailingList = list || [];
  //         this.loadingElement = '';
  //       },
  //       err => {
  //         toastr.error(this.translateService.instant('action.failed'));
  //         this.loadingElement = '';
  //       }
  //     );
  //   }
  // }

  // removeEmailAddress(email: string) {
  //   this.mailingList.splice(this.mailingList.indexOf(email), 1);
  // }

  // addEmailAddress() {
  //   this.mailingList.push(this.mailingAddress);
  //   this.mailingAddress = '';
  // }

  importMailingList() {
    this.mailingList = union(this.mailingList, this.validateResults.validEmails);
    this.onSaveMailingList.emit({ type: this.email.type, mailingList: this.mailingList });
    this.fileUpload.reset();
  }

  // clearMailingList() {
  //   this.mailingList = [];
  //   this.saveMailingList();
  // }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, Object.assign({}, { class: 'inmodal' }));
  }

  sendMails() {
    this.remainingMailingList = [];
    this.showModal(this.sendMailsModal);
    if (this.isInvitations()) {
      this.emailService.getMailingListToSend(this.session, this.email.type).subscribe(list => {
        this.remainingMailingList = list || [];
      })
    }
  }

  public resendMails(): void {
    const modal = this.modalService.show(ConfirmationModalComponent);
    (<ConfirmationModalComponent>modal.content).showConfirmationModal(
        this.translateService.instant('sessions.details.emails.confirm_send')
    );

    const closeSource$ = (<ConfirmationModalComponent>modal.content).onClose;
    closeSource$.subscribe(result => {
        if (result) {
          this.onReSendMail.emit({ type: this.email.type });
        }
    });
  }

  showPreview() {
    this.loadingElement = 'preview';
    const preview = open('url', this.email.subject, 'height=650,width=700');
    preview.document.write(loader);
    this.emailService.retrieveMailPreview(this.session, this.email.type).subscribe(
      ({ content }) => {
        preview.document.body.innerHTML = '';
        preview.document.write(content);
        this.loadingElement = '';
      },
      err => {
        toastr.error(this.translateService.instant('action.failed'));
        this.loadingElement = '';
        preview.close();
      }
    );
    return preview;
  }

  onDemand() {
    this.emailService.getMailingList(this.session, this.email.type).subscribe(
      list => {
        const modal = this.modalService.show(MailingListModalComponent, { class: 'inmodal' });
        const registered = list || [];
        (<MailingListModalComponent>modal.content).showModal(
          {
            title: this.translateService.instant('sessions.details.emails.send_ondemand_title'),
            confirmTitile: this.translateService.instant('sessions.details.emails.send_ondemand_confirm'),
            clearButton: this.translateService.instant('sessions.details.emails.clear_mailing'),
            confirmButton: this.translateService.instant('sessions.details.emails.send_now'),
            cancelButton: this.translateService.instant('common.cancel')
          }, [] 
        ).subscribe(({add, remove, update}) => {
          if (update.length > 0) {
            const toSend = reduce((acc, e) => {
              if(contains(e, registered)) {
                acc.send.push(e);
              } else {
                acc.ignore.push(e);
              }
              return acc;
            }, {send: [], ignore: []}, update);
            if (toSend.send.length > 0) {
              this.onSendOndemandMail.emit({ type: this.email.type, mailingList: toSend.send });
            }
            if (toSend.ignore.length > 0) {
              this.ignoredEmails = toSend.ignore;
              this.showModal(this.ignoredEmailsWarning)
            }
          }
        });
      },
      err => {
        toastr.error(this.translateService.instant('action.failed'));
        this.loadingElement = '';
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/email/editor-2/editor.component.ts